import React from "react";
import "./Aboutus.css";

const AboutUs = () => {
  return (
    <div className="aboutus" id="AboutUs">
      <div className="aboutus-container">
        <h1>About Hobbestie</h1>
        <p>
          Hobbestie is where your passions bring people together! Whether you're
          into painting, coding, hiking, or discovering the next big trend, this
          is the place to connect, share, and dive deep into what you love.
        </p>
        <h2>Our Mission</h2>
        <p>
          Here, every hobby has a home. Share your latest projects, spark
          conversations, join like-minded communities, or even start your own
          space dedicated to your interests. No matter how niche or mainstream
          your passion is, you’ll always find people who just get it.
        </p>
        <h2>Features</h2>
        <ul>
          <li>
            Personalized Home Feed - See the latest posts, videos, and
            discussions from people who share your interests. If you have
            friends, their content comes first. If not, we’ll help you find your
            perfect hobby squad!
          </li>
          <li>
            Multi-Format Posting - Share your hobbies in the way that suits you
            best—photos, videos, text thoughts, or even dedicated channels where
            you can build a following.
          </li>
          <li>
            Custom Hobby Channels - Create or join hobby-specific channels to
            dive deep into conversations, share tips, and showcase your skills
            in a focused space.
          </li>
          <li>
            Forum & Threads – Go beyond quick posts and engage in deeper
            discussions, debates, and collaborative projects with structured
            threads.
          </li>
          <li>
            Sell Digital Products – Turn your creativity into income! Sell
            exclusive content, tutorials,classes, digital art, templates, music,
            or any digital product directly to your audience.
          </li>
        </ul>

        <h2>Company address</h2>
        <p>Samarinda, Indonesia 🇮🇩</p>
      </div>
    </div>
  );
};

export default AboutUs;
